import { differenceWith } from "lodash";
import { PureCustomValue } from "PFTypes";

export const areValuesEqual = (valuesOne: PureCustomValue[], valuesTwo: PureCustomValue[]) =>
  valuesOne.length === valuesTwo.length &&
  differenceWith(valuesOne, valuesTwo, (valueOne, valueTwo) => valueOne.id === valueTwo.id).length === 0;
